module.exports = __webpack_public_path__ + "static/media/cash.ba23fb42.svg";